import { Link } from 'react-router-dom';
import {
  Gauge,
  Search,
  Users,
  Quote,
  Lightbulb,
  History,
  ShieldCheck,
  Layers,
  ArrowRight,
} from 'lucide-react';
import { Button } from '@/components/ui/Button';

const sections = [
  {
    icon: Search,
    title: 'Website inspection & brand inference',
    body: 'Enter only a URL. We inspect your title, meta description, Open Graph data, schema.org markup, and headings to infer your brand, category, and likely competitors — then let you confirm before running.',
  },
  {
    icon: Gauge,
    title: 'Composite visibility scoring',
    body: 'A transparent 0–100 Visibility Score built from mention rate, recommendation rate, top-3 inclusion, position, share of voice, sentiment, and accuracy.',
  },
  {
    icon: Quote,
    title: 'Mentions & recommendations',
    body: 'Per-prompt detection of whether your brand is mentioned, actively recommended, and where it ranks among alternatives.',
  },
  {
    icon: Users,
    title: 'Competitor share of voice',
    body: 'See which competitors surface most often across category, comparison, and commercial-intent prompts.',
  },
  {
    icon: Lightbulb,
    title: 'Prioritized recommendations',
    body: 'Practical opportunities with priority, affected prompts, the reason, and a specific recommended action.',
  },
  {
    icon: History,
    title: 'Projects, history & tracking',
    body: 'Registered users can save projects, keep analysis history, rerun analyses, and compare current results with previous runs.',
  },
  {
    icon: ShieldCheck,
    title: 'Secure by design',
    body: 'Server-side entitlements, SSRF-protected inspection, Turnstile protection, and strict data access rules.',
  },
  {
    icon: Layers,
    title: 'Six prompt categories',
    body: 'Discovery, category recommendation, comparison, problem solving, high commercial intent, and branded audit.',
  },
];

export function Features() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="text-4xl font-bold tracking-tight text-text-primary">Features</h1>
        <p className="mt-4 text-lg text-text-secondary">
          A complete view of how your brand may be represented in AI-generated answers.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2">
        {sections.map((s) => (
          <div key={s.title} className="panel p-6">
            <span className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-accent-indigo/10 text-accent-indigo">
              <s.icon size={20} />
            </span>
            <h3 className="mb-2 text-lg font-semibold text-text-primary">{s.title}</h3>
            <p className="text-sm text-text-secondary">{s.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <Link to="/analyze">
          <Button size="lg">
            Analyze your website <ArrowRight size={18} />
          </Button>
        </Link>
      </div>
    </div>
  );
}
